module.exports = __webpack_public_path__ + "img/no-go-min.47d06397.jpg";